import React from "react";
import Checkbox from "components/Checkbox";
import { useTranslation } from "react-i18next";
import { buildingSettingsStore } from "../BuildingSettingsStore";
import { BuildingOUT } from "api-client";
import { observer } from "mobx-react-lite";

const AutomaticProductMapping = () => {
  const { t } = useTranslation();
  const { settings } = buildingSettingsStore;

  const mappingItems = [
    {
      id: "premapping_enabled",
      title: t("buildingSettings.restorePreviousMappings"),
      subTitle: t("buildingSettings.restorePreviousMappingsSubtitle"),
    },
  ];

  return (
    <div>
      <div className="text-lg font-semibold mb-2">
        {t("buildingSettings.automaticProductMapping")}
      </div>
      <div className="text-sm text-gray-700 pb-5">
        {t("buildingSettings.automaticProductMappingDesc")}
      </div>
      {mappingItems.map((item) => (
        <div className="flex items-center mb-6" key={item.id}>
          <Checkbox
            id={item.id}
            checked={Boolean(settings[item.id as keyof BuildingOUT])}
            onChange={(e) =>
              buildingSettingsStore.onChangeValue(
                e.currentTarget.checked,
                item.id
              )
            }
            className="mr-2"
          />
          <div>
            <div className="text-sm font-medium text-gray-700">
              {item.title}
            </div>
            <div className="text-sm font-normal text-gray-500">
              {item.subTitle}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default observer(AutomaticProductMapping);
